import { registerMutation, registerSubscription } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { BehaviorSubject } from 'rxjs';
import { SchedulingState, type SchedulingPhase } from '../entities/SchedulingState.js';
import { gateNexusSchedulingSubscription } from './assert-nexus-scheduling-access.js';

export const schedulingState$ = new BehaviorSubject<SchedulingState>(
  new SchedulingState({ phase: 'idle', message: 'Scheduling not started', updatedAt: new Date() }),
);

export function updateSchedulingState(update: {
  phase: SchedulingPhase;
  message: string;
  ticketsViewedCount?: number;
  ticketsToScheduleCount?: number;
  ticketsWithFECount?: number;
  availableFECount?: number;
  routesCount?: number;
  error?: string;
}) {
  schedulingState$.next(
    new SchedulingState({
      ...update,
      updatedAt: new Date(),
    }),
  );
}

export function resetSchedulingState() {
  schedulingState$.next(
    new SchedulingState({ phase: 'idle', message: 'Scheduling not started', updatedAt: new Date() }),
  );
}

export const subscribeSchedulingState = registerSubscription({
  operationName: 'subscribeSchedulingState',
  type: () => SchedulingState,
  resolve: () => (_gqlFields: BaseQLSelectionSet<SchedulingState>) =>
    gateNexusSchedulingSubscription(() => schedulingState$.asObservable()),
});

export const clearSchedulingState = registerMutation({
  operationName: 'clearSchedulingState',
  type: () => Boolean,
  resolve: () => async () => {
    resetSchedulingState();
    return true;
  },
  params: [],
});
